import "./App.css";
import About from "./Components/About";
import Header from "./Components/Header";
import Hero from "./Components/Hero";
import Work from "./Components/Work";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import YouTubeIcon from "@material-ui/icons/YouTube";
import GitHubIcon from "@material-ui/icons/GitHub";
import FacebookIcon from "@material-ui/icons/Facebook";
import OtherProjects from "./Components/OtherProjects";
import Contact from "./Components/Contact";
import ScrollButton from "./Components/ScrollButton";
import Ui from "./Components/Ui";

function App() {
  return (
    <div className="App">
      <div className="social__icons">
        <a
          target="_blank"
          href="https://github.com/khansaud3551?tab=repositories"
        >
          <GitHubIcon />
        </a>
        <a
          target="_blank"
          href="https://www.linkedin.com/in/shah-saud-khan-36a304216/"
        >
          <LinkedInIcon />
        </a>
        <a target="_blank" href="https://www.instagram.com">
          <InstagramIcon />
        </a>
        <a target="_blank" href="https://twitter.com/saudkhan3551">
          <TwitterIcon />
        </a>
        <a target="_blank" href="https://www.youtube.com">
          <YouTubeIcon />
        </a>
        <a target="_blank" href="https://www.facebook.com">
          <FacebookIcon />
        </a>
        <span></span>
      </div>
      <div className="myemail">
        <a href="mailto:khansaud150@gmail.com">
          khansaud150@gmail.com@gmail.com
        </a>
        <span></span>
      </div>
      <Header />
      <Hero />
      <About />
      <Work />
      <OtherProjects />
      <Ui />
      <Contact />
      <ScrollButton />
    </div>
  );
}

export default App;
